// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// Import all channels.
// import '~/channels/index.js'
// const channels = import.meta.globEager('./**/*_channel.js')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import '@fortawesome/fontawesome-free/js/all'
import $ from 'jquery';
import '@/stylesheets/application.scss';
import '@/components/themeToggle.js';

window.$ = $;

Rails.start()
ActiveStorage.start()

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)